import axios from 'axios'

const myAxios = axios.create({
  timeout: 600000,
})

// 请求拦截器
myAxios.interceptors.request.use(
  (config) => {
    config.headers['refer'] = window.location.href
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
myAxios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.code == 'ECONNABORTED') {
      alert('请求超时，请检查网络连接！')
    }
    if (error.response.status === 401) {
    }
    return Promise.reject(error)
  }
)

export default myAxios
